import React from 'react'
import flatMap from 'lodash/flatMap'

import { Liabilities } from '@containers/Liabilities'
import { ParticipantFilter } from './ParticipantFilter'

export const JointLiabilities = ({ participantsQueries, config }) => {
  const [selectedParticipantId, setSelectedParticipantId] = React.useState('both')
  const selectedParticipantQuery = participantsQueries.find((participantQuery) => participantQuery.participant.id === selectedParticipantId)

  const liabilities = selectedParticipantQuery
    ? selectedParticipantQuery.liabilities.data
    : flatMap(participantsQueries, (participantQuery) => participantQuery.liabilities.data)

  return (
    <>
      <Liabilities
        filter={ (view) => (
          <ParticipantFilter
            showBoth
            filteredItemsName={'liabilities'}
            view={view}
            participantsQueries={participantsQueries}
            selectedParticipantId={selectedParticipantId}
            setSelectedParticipantId={setSelectedParticipantId}
          />
        )}
        scenario={{
          id: selectedParticipantQuery?.scenario.data.baseScenario.id,
        }}
        liabilities={liabilities}
        crudActions={selectedParticipantQuery?.liabilities.actions}
        tenant={config.tenant}

        supportedLiabilityTypes={config.supportedLiabilityTypes}
        featureToggles={config.featureToggles}
      />
    </>
  )
}
